import { API } from '@/services/api'

export function getMortgageByBuildingID(buildingID) {
  return API.get(`/mortgage/summary/${buildingID}`)
}

export const widgetService = { getMortgageByBuildingID }
